import dayNightImg from "../images/afro-solar/agri-solar/pumping-system.webp";
import submersibleImg from "../images/afro-solar/agri-solar/submersible-water-pump.webp";
import surfaceWater from "../images/afro-solar/agri-solar/surface-water-pump.webp";

const pumpingSystems = [
  {
    title: "Pumping Systems",
    description:
      "Water your fields with the power from the sun With the cost of diesel and electricity rising constantly, solar powered water pumps are the perfect alternative for rural regions as these have a low maintenance cost and ensure a long product life.",
    img: dayNightImg,
  },
  {
    title: "Surface Water Pumps​",
    description:
      "Surface pumps range from AFRO Solar supports varied applications like field irrigation or supplying potable water to your communities, while drawing water from nearby water sources like lakes, ponds, canals or rivers.",
    img: surfaceWater,
  },
  {
    title: "Submersible Water Pumps​",
    description:
      "Submersible pumps range from AFRO Solar supports varied applications like field irrigation or supplying potable water for your communities, while drawing water from underground water sources like bore-wells or sumps.",
    img: submersibleImg,
  },
];

const solarPumpsHelpingWays = [
  {
    title: "Smart Controller for Dawn to Dusk Operation",
    img: dayNightImg,
  },
  {
    title: "Consistent Water Output Year on Year",
    img: surfaceWater,
  },
  {
    title: "SP54 Water Ingress Protection for Electronics",
    img: submersibleImg,
  },
];

const AgriSolar = () => {
  return (
    <div className="container-fluid pt-7" id="agri-solar">
      <div className="me-13 ms-13 pt-7">
        <div className="text-center pb-7">
          <h1 className="fs-56 lh-64 gilroy-bold">
            AGRI-<span className="text-orange-ryb">SOLAR</span>
          </h1>
          <h3 className="fs-18 gilroy-bold mt-4">
            How do solar water pumps help rural regions?
          </h3>
          <p className="fs-16 lh-30">
            People from rural regions have to work additionally hard for water,
            especially due to the unpredictable nature of rain in the country.
          </p>
          <p className="fs-16 lh-30">
            Our solar powered water pumps are a low cost solution enabling
            residents in these areas to spend more time increasing their income
            by growing crops etc., rather than ferrying water from far off
            distances.
          </p>
        </div>

        <div className="row g-3 justify-content-center">
          {pumpingSystems.map((system) => (
            <div
              className="col-12 col-sm-6 col-md-6 col-lg-4 text-center"
              key={system.title}
            >
              <div
                className="h-100 p-4 m-4 card-design-3"
                style={{ boxShadow: "rgb(0 0 0 / 15%) 1.95px 1.95px 2.6px" }}
              >
                <img
                  src={system.img}
                  alt={system.title}
                  className="img-fluid card-design-2"
                />
                <h3 className="fs-18 gilroy-bold mt-2">{system.title}</h3>
                <p className="fs-16 lh-30 mt-4">{system.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="row mt-5 justify-content-center">
          {solarPumpsHelpingWays.map((way) => (
            <div
              className="col-12 col-sm-6 col-md-6 col-lg-4 text-center pb-4"
              key={way.title}
            >
              <div
                className="h-100 p-4 m-4 card-design-3"
                style={{ boxShadow: "rgb(0 0 0 / 15%) 1.95px 1.95px 2.6px" }}
              >
                <img
                  src={way.img}
                  loading="lazy"
                  alt={way.title}
                  className="img-fluid card-design-2"
                />
                <h3 className="fs-18 gilroy-bold mt-3">{way.title}</h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AgriSolar;
